import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=79c2a60a"
import script from "./InputWithLabel.vue?vue&type=script&lang=ts"
export * from "./InputWithLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports